import Vue from "vue";

export const optionEnabled = Vue.observable({ value: [] });

export default {
  get() {
    return optionEnabled.value;
  },
  set(active) {
    optionEnabled.value = active;
  },
};
